import React from 'react';
import SEO from '../components/SEO';

export default function Imprint({ lang }) {
  const seoData = {
    en: {
      title: 'Imprint',
      description: 'Legal information and contact details for the Barbera del Vallès Beer Pass.'
    },
    es: {
      title: 'Aviso Legal',
      description: 'Información legal y detalles de contacto para el Pase Cervecero de Barberà del Vallès.'
    }
  };

  const currentSeo = seoData[lang];

  const content = {
    en: {
      title: 'Imprint',
      sections: [
        {
          h: 'Legal Entity',
          p: 'Mathias Deppe'
        },
        {
          h: 'Address',
          p: 'Nemesi Valls 42\n08210 Barberà del Vallès\nSpain'
        },
        {
          h: 'Contact',
          p: 'Email: contact@barberadelvalles.beer'
        }
      ]
    },
    es: {
      title: 'Aviso Legal',
      sections: [
        {
          h: 'Responsable Legal',
          p: 'Mathias Deppe'
        },
        {
          h: 'Dirección',
          p: 'Nemesi Valls 42\n08210 Barberà del Vallès\nEspaña'
        },
        {
          h: 'Contacto',
          p: 'Email: contact@barberadelvalles.beer'
        }
      ]
    }
  };

  const current = content[lang];

  return (
    <section className="w-full py-16 animate-in fade-in slide-in-from-bottom-4 duration-700">
      <SEO title={currentSeo.title} description={currentSeo.description} lang={lang} />
      
      <h1 className="text-5xl sm:text-7xl font-black uppercase mb-12 border-b-8 border-amber-400 pb-4 inline-block">
        {current.title}
      </h1>
      
      <div className="grid gap-12">
        {current.sections.map((sec, i) => (
          <div key={i} className="border-l-4 border-white pl-6">
            <h2 className="text-2xl font-black uppercase text-amber-400 mb-4">{sec.h}</h2>
            <p className="text-xl font-bold text-gray-300 whitespace-pre-line leading-relaxed">
              {sec.p}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}